<template>
    <div class="field">
        <label class="label">Login as this User</label>
        <div class="control">
            <a class="button is-info is-fullwidth" @click.prevent="loginAsThisUser(user)">Login As {{ user.name }}</a>
        </div>
    </div>
</template>

<script>
    import apiUsers from './../../../../api/apiUsers'
    export default {
        props: ['user'],
        methods: {
            loginAsThisUser(user) {
                let data = {
                    user: user
                }
                apiUsers
                    .loginAsOtherUser(data)
                    .then((response) => {
                        this.$store.commit('removeToken')
                        this.$store.commit('removeRole')
                        this.$store.commit('removeUserName')
                        this.$store.commit('updateToken', response.data.token)
                        this.$store.commit('updateRole', response.data.role)
                        this.$store.commit('updateUserReferer', (response.data.referer || response.data.role == 'Affiliate') ? 1 : 0 )
                        this.$store.commit('updateUserName', response.data.name)
                        this.$store.commit('updateUserDeposit', response.data.deposit)
                        this.$store.commit('updateUserDepositRate', response.data.rate)
                        this.$store.commit('updateUserDueAmount', response.data.due)
                        this.$store.dispatch('setCurrentUserCarHiddenFields', response.data.car_hidden_fields)
                        this.$router.push({ path: '/system' })
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Inputs/UserLogin.vue